import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { SolidButton, TransparentButton } from "../../../../library/button";
import { changeTemplatesModal } from "../../../../../redux/actions/templates";
import Interweave from "interweave";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from "../../../../library/popup";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const modalState = useSelector(
    (state) => state.templates.showModals.viewModal
  );

  const activeTemplate = useSelector((state) => state.templates.activeTemplate);

  const [templateDisplay, setTemplateDisplay] = useState({
    id: null,
    type: null,
    title: null,
    html: null,
    message: null,
  });

  const handleClose = () => {
    dispatch(changeTemplatesModal({ viewModal: false }));
  };

  useEffect(() => {
    if (Object.keys(activeTemplate).length > 0) {
      setTemplateDisplay(activeTemplate);
    }
  }, [activeTemplate]);

  const clickEditTemplate = () => {
    dispatch(changeTemplatesModal({ viewModal: false }));
    history.push(`/dashboard/mal/${templateDisplay.id}`);
  };

  const renderTemplate = () => {
    if (templateDisplay.type === "email") {
      return templateDisplay.html;
    } else {
      return templateDisplay.message;
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Visning av mal"
      description="Nedenfor ser du hvordan malen du har opprettet ser ut i HTML-format gjennom vår WYSIWYG-editor."
      buttons={[
        <TransparentButton
          title="Avbryt"
          id="closeButtonAdd"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          onClick={() => clickEditTemplate()}
          color="blue"
          title={"Rediger"}
          icon={<i class="fad fa-pen-alt"></i>}
          type="button"
        />,
      ]}
    >
      <div className="view-template-content-container">
        <Interweave
          content={renderTemplate()}
          className="view-template-container"
        />
      </div>
    </Popup>
  );
};

export default Index;
